import axios from 'axios'

class DesentranhamentoDocumentoPedidoApi {
	async juntarTermoDesentranhamento(idDocumento) {
		return await axios.put(`api/pedido/documentos/${idDocumento}/processo-digital/termo-desentranhamento`)
	}

	async criarTermoDesentranhamento(idDocumento) {
		return await axios.post(`api/pedido/documentos/${idDocumento}/gerar-termo-desentranhamento`)
	}
}

export default new DesentranhamentoDocumentoPedidoApi()
